export interface IQuiltSize {
    readonly width: number;
    readonly height: number;
}

export const ZeroQuiltSize: IQuiltSize = {
    width: 0,
    height: 0
};